function toggleSelected(clickedElement) {
    var multiSelectItems = document.querySelectorAll('.btn-multi-select');
    multiSelectItems.forEach(function (item) {
        item.classList.remove('selected');
    });
    clickedElement.classList.add('selected');
}